import React, { useEffect, useState } from 'react';
import { CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react';
import { Button } from '@transferz/components';
import { Action } from '@transferz/models';
import { Form } from './Form';
import { Loading } from '../loading/Loading';

interface IModalFormProps {
  id: string;
  titleText: string;
  bodyText?: string;
  bodyTextMore?: string;
  warningBoxText?: string;
  data: any;
  formFields: any;
  showModal: boolean;
  setShowModal: Function;
  isLoading: boolean;
  isDisabled?: boolean;
  onSubmit: (data: any) => Promise<void>;
  confirmButtonTitle?: string;
  closeOnSubmit?: boolean;
}

export const ModalForm: React.FC<IModalFormProps> = ({
  id,
  titleText,
  bodyText,
  bodyTextMore,
  warningBoxText,
  data,
  formFields,
  showModal,
  setShowModal,
  isLoading,
  isDisabled,
  onSubmit,
  confirmButtonTitle,
  closeOnSubmit = true,
}) => {
  const [action, setAction] = useState(Action.Create);

  useEffect(() => {
    if (showModal && Object.keys(data).length) {
      setAction(Action.Update);
    } else {
      setAction(Action.Create);
    }
  }, [showModal, data, setAction]);

  const handleModalChange = (showModal = false) => {
    setShowModal(showModal);
  };

  return (
    <>
      <CModal
        show={showModal}
        onClose={handleModalChange}
      >
        <CModalHeader closeButton>
          <CModalTitle>{titleText}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {isLoading
            ? <Loading />
            : (
              <>
                {warningBoxText && <p className="mb-3 p-3 alert-warning alert">{warningBoxText}</p>}
                {bodyText && <p className="mb-3">{bodyText}</p>}
                {bodyTextMore && <p className="mb-3">{bodyTextMore}</p>}
                <Form
                  id={id}
                  data={data}
                  key={showModal ? 1 : 0}
                  fields={formFields}
                  onSubmit={async (formData: any) => {
                    return onSubmit(formData)
                      .then(() => {
                        if (closeOnSubmit) {
                          setShowModal(false);
                        }
                      })
                  }}
                />
              </>
            )
          }
        </CModalBody>
        <CModalFooter>
          <Button
            color="secondary"
            title="Cancel"
            disabled={isLoading}
            onClick={() => handleModalChange()}
          />
          <Button
            className="ml-1"
            type="submit"
            form={id}
            color="primary"
            title={confirmButtonTitle ? confirmButtonTitle : (action === Action.Create ? 'Create' : 'Update')}
            loading={false}
            disabled={isDisabled}
          />
        </CModalFooter>
      </CModal>
    </>
  )
};

export default ModalForm;
